import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewContainerRef } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { LCS_SINGLE_SELECT_OPTIONS, LcsSingleSelectBase } from '../../single-select/single-select-base';
import { CallRetentionPolicyOption } from '../models/call-retention-policy-option';
import { callRetentionPolicyOptionSelectors } from '../state/call-retention-policy-option.reducer';

@Component({
    providers: [
        {
            provide: LCS_SINGLE_SELECT_OPTIONS,
            useExisting: CallRetentionPolicySelectComponent,
        },
    ],
    selector: 'ndt-call-retention-policy-select',
    templateUrl: './call-retention-policy-select.component.html',
    standalone: false
})
export class CallRetentionPolicySelectComponent
   extends LcsSingleSelectBase<CallRetentionPolicyOption>
   implements OnInit
{
   callRetentionPolicies: Observable<CallRetentionPolicyOption[] | null>;

   constructor(
      protected elementRef: ElementRef,
      protected changeDetectorRef: ChangeDetectorRef,
      protected viewContainerRef: ViewContainerRef,
      private store: Store
   ) {
      super(elementRef, changeDetectorRef, viewContainerRef);
   }

   ngOnInit(): void {
      this.callRetentionPolicies = this.store.pipe(
         select(callRetentionPolicyOptionSelectors.selectFilteredItems),
         this.itemsLoaded()
      );
   }

   displayWith(item: CallRetentionPolicyOption | null): string | null {
      if (item?.callRetentionPolicy === 'Eighteen') {
         return '18 Months';
      } else if (item?.callRetentionPolicy === 'ThirtySix') {
         return '36 Months';
      } else if (item?.callRetentionPolicy === 'Sixty') {
         return '60 Months';
      } else if (item?.callRetentionPolicy === 'NegativeOne') {
         return 'Unset';
      }
      return item?.callRetentionPolicy ? item.callRetentionPolicy : null;
   }

   trackBy(item: CallRetentionPolicyOption | null) {
      return item ? item.callRetentionPolicy : null;
   }
}
